import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import App from './App.tsx';
import './index.css';

// Set up environment variables fallback
if (typeof import.meta.env.VITE_SUPABASE_URL === 'undefined' && window.ENV) {
  Object.keys(window.ENV).forEach(key => {
    // @ts-ignore
    import.meta.env[key] = window.ENV[key];
  });
  
  console.log('Using fallback environment variables');
  console.log('Supabase URL:', import.meta.env.VITE_SUPABASE_URL);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>
);

// Add event listener for video fullscreen
document.addEventListener('DOMContentLoaded', () => {
  // Wait for iframe to load
  setTimeout(() => {
    const videoFrame = document.querySelector('.video-frame');
    if (videoFrame) {
      videoFrame.addEventListener('click', function() {
        const iframe = videoFrame as HTMLIFrameElement;
        if (document.fullscreenElement) {
          document.exitFullscreen().catch(err => {
            console.error(`Error exiting fullscreen: ${err.message}`);
          });
        } else {
          iframe.requestFullscreen().catch(err => {
            console.error(`Error attempting to enable fullscreen: ${err.message}`);
          });
        }
      });
    }
  }, 2000); // Give time for iframe to load
});